<template><div>


    <span v-if="cstore.getCruiseBook.resolve.roomDetail.svgjpg.is"><ShowHideB>
        <template #title>
            <div class="sch">
                <div class="sch-blo">
                    <div class="sch-h">{{cstore.getCruiseBook.resolve.ship.name}}</div>
                    <button class="btn btn--ora sch-b">Смотреть схему</button>
                </div>
            </div>
        </template>
        <template>
            <BigScheme
                :scheme="cstore.getCruiseBook.resolve.roomDetail.svgjpg"
                :CabinMap="cstore.getCruiseBook.CabinMap" 
                class="sch__BigScheme"
                show="all"
                >
            </BigScheme>
        </template>
    </ShowHideB></span>



    <div class="cabin-type" v-if="!PriceTreeFree.length">
        <div class="cabin-type__cat-selector">
            <div class="cabin-type__free-cabins--no-free">Нет свободных кают</div>
        </div>
    </div>

    <div class="cabin-type" v-for="({CabinSet, CabinsFree}) in PriceTreeFree">
        <div class="cabin-type__slider">
            <MySlider  :slides="CabinSet.photos" :convertCdn="true"
            srcKey="src"
            idKey="id"
            :slideRatio="4 / 6"
            />
        </div>

        <div class="cabin-type__info">
            <div class="cabin-type__name">{{CabinSet.name}}</div>
            <div class="cabin-type__section">
                <div class="cabin-type__section-name">Расположение:</div>
                <div class="cabin-type__section-value">{{CabinSet.decks.length ? CabinSet.decks[0].name : '—————'}}</div>
            </div>
            <div class="cabin-type__section cabin-type__section--price">
                <div class="cabin-type__section-name">Стоимость:</div>
                <div class="cabin-type__section-value"><PriceCurrencyV :price="CabinSet.baseprice" /></div>
            </div>
        </div>

        <div class="cabin-type__free-cabins"  v-if="CabinsFree.length">
            <div class="cabin-type__free-cabins-title">{{numWord(CabinsFree.length, ['свободна', 'свободных', 'свободных'])}}</div>
            <div class="cabin-type__rooms">
                <RoomSelector 
                    v-for="cab in CabinsFree" :key="cab.id" 
                    :Cabin="cab" :CabinSet="CabinSet" 
                />

            </div>
        </div>
         <div class="cabin-type__free-cabins--no-free" v-else>Нет свободных кают</div>

    </div>

</div></template>

<style lang="scss" src="./SelectCabins.scss"></style>

<script setup>
import {ref, unref, shallowRef, computed, onMounted} from 'vue'
import useCruiseStore from '@/cstore.js'
import Mest from '@/comp/CruiseHead/Mest.vue'
import RoomSelector from './RoomSelector.vue'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'
import MySlider from '@/comp/MySlider/MySlider.vue'
import { formatPrice, numWord } from '@/util.js'

import ShowHideB from '@/comp/ShowHide/ShowHideB.vue'
import BigScheme from '@/comp/BigScheme/BigScheme.vue'

const cstore=useCruiseStore()

const PriceTreeFree = computed( () => {
    return unref(cstore.getCruiseBook.PriceTree).filter( ({CabinsFree}) => CabinsFree.length > 0  )
})


</script>
